window.addEventListener("load", (event) => {
  applyFilters();
  remove_filter();

  sortByoptions();
  // SidedrawerEventInit();
});

window.addEventListener("resize", (event) => {
  if (
    window.innerWidth > 1024 &&
    document.querySelector("#Collection-filter-sidebar")
  ) {
    document
      .querySelector("#Collection-filter-sidebar")
      .style.removeProperty("display");
  }
});

let triggered = false;

function fetchFilterData(url, options = {}) {
  return fetch(url, options).then((response) => {
    if (!response.ok) {
      throw new Error(`Collection request failed: ${response.status}`);
    }

    return response.text();
  });
}

let collectionHistoryController = null;
let lastRenderedCollectionUrl =
  window.location.pathname + window.location.search;

function normalizeCollectionUrl(url) {
  const parsedUrl = new URL(url, window.location.origin);
  return parsedUrl.pathname + parsedUrl.search;
}

function buildCollectionSectionUrl(url, sectionId) {
  const parsedUrl = new URL(url, window.location.origin);

  parsedUrl.searchParams.delete("section_id");
  parsedUrl.searchParams.set("section_id", sectionId);

  return parsedUrl.pathname + parsedUrl.search;
}

function reinitializeCollection(sectionParent, sectionId) {
  if (typeof applyFilters === "function") {
    applyFilters();
  }

  if (typeof remove_filter === "function") {
    remove_filter(sectionParent, sectionId);
  }

  if (typeof SidedrawerEventInit === "function") {
    SidedrawerEventInit();
  }

  if (typeof collectionSwatch === "function") {
    collectionSwatch();
  }

  if (typeof sortByoptions === "function") {
    sortByoptions();
  }

  triggered = false;

  if (typeof loadMoreCollection === "function") {
    loadMoreCollection();
  }

  if (typeof getCountDownElments === "function") {
    getCountDownElments();
  }

  if (typeof quickviewElements === "function") {
    quickviewElements();
  }

  if (typeof customDropdownElements === "function") {
    customDropdownElements();
  }

  if (typeof productCardHoverInit === "function") {
    productCardHoverInit();
  }

  if (typeof bindMobileSortOutsideClick === "function") {
    bindMobileSortOutsideClick();
  }

  if (typeof aosAnimation !== "undefined" && aosAnimation) {
    if (typeof AOS !== "undefined" && AOS) {
      AOS.refreshHard();
    }
  }
}

function renderCollectionFromHistory(targetUrl) {
  const currentProducts = document.getElementById(
    "CollectionProductsParent"
  );

  if (!currentProducts) {
    return;
  }

  const sectionId = currentProducts.dataset.id;
  const sectionParent = currentProducts.closest(".shopify-section");

  if (!sectionId || !sectionParent) {
    window.location.reload();
    return;
  }

  if (collectionHistoryController) {
    collectionHistoryController.abort();
  }

  collectionHistoryController = new AbortController();

  const requestUrl = buildCollectionSectionUrl(
    targetUrl,
    sectionId
  );

  fetchFilterData(requestUrl, {
    signal: collectionHistoryController.signal,
  })
    .then((responseText) => {
      const resultData = new DOMParser().parseFromString(
        responseText,
        "text/html"
      );

      const newProducts = resultData.getElementById(
        "CollectionProductsParent"
      );

      const newSidebar = resultData.querySelector(
        ".collection-filter-sidebar"
      );

      const currentSidebar = document.querySelector(
        ".collection-filter-sidebar"
      );

      const newMobileSort = resultData.querySelector(
        "[data-mobile-sort]"
      );

      const currentMobileSort = document.querySelector(
        "[data-mobile-sort]"
      );

      if (!newProducts) {
        throw new Error(
          "Collection section was not returned"
        );
      }

      currentProducts.innerHTML =
        newProducts.innerHTML;

      if (currentSidebar && newSidebar) {
        currentSidebar.innerHTML =
          newSidebar.innerHTML;
      }

      if (currentMobileSort && newMobileSort) {
        currentMobileSort.innerHTML =
          newMobileSort.innerHTML;
      }

      syncTopbarClearAll(resultData);

      lastRenderedCollectionUrl =
        normalizeCollectionUrl(targetUrl);

      reinitializeCollection(
        sectionParent,
        sectionId
      );

      document.dispatchEvent(
        new CustomEvent("collectionFilterUpdated", {
          detail: {
            url: lastRenderedCollectionUrl,
            historyNavigation: true,
            doc: resultData,
          },
        })
      );
    })
    .catch((error) => {
      if (error.name === "AbortError") {
        return;
      }

      console.error(
        "Unable to restore collection history state:",
        error
      );

      window.location.reload();
    });
}

window.addEventListener("popstate", () => {
  const restoredUrl =
    window.location.pathname +
    window.location.search;

  if (restoredUrl === lastRenderedCollectionUrl) {
    return;
  }

  renderCollectionFromHistory(restoredUrl);
});

document.addEventListener(
  "collectionFilterUpdated",
  (event) => {
    const updatedUrl =
      event.detail && event.detail.url;

    lastRenderedCollectionUrl =
      normalizeCollectionUrl(
        updatedUrl || window.location.href
      );
  }
);

function applyFilters() {
  let section = document.getElementById(
    "CollectionProductsParent"
  );

  let filterForm =
    document.getElementById("FiltersForm");

  if (!section || !filterForm) {
    return false;
  }

  const separeted_filter_items =
    filterForm.querySelector(
      ".applied-filter-container"
    );

  const main_applied_filter_container =
    document.querySelector(
      ".applied-filter-container-main"
    );

  if (separeted_filter_items) {
    const cloned_filter_container =
      separeted_filter_items.cloneNode(true);

    cloned_filter_container
      .querySelectorAll(".applied__filter-item")
      .forEach((item) => {
        item.classList.remove("hidden");
      });

    if (main_applied_filter_container) {
      main_applied_filter_container.innerHTML =
        cloned_filter_container.innerHTML;
    }
  } else if (main_applied_filter_container) {
    main_applied_filter_container.innerHTML = "";
  }

  let sectionParent =
    section.closest(".shopify-section");

  let sectionId = section.dataset.id;

  if (section) {
    if (!filterForm) {
      return false;
    }

    collection_price_range(
      sectionId,
      sectionParent
    );

    let inputs = filterForm.querySelectorAll(
      "input[type=checkbox]"
    );

    Array.from(inputs).forEach(function (input) {
      input.addEventListener("click", () => {
        SidedrawerEventInit();
        getFilterData(input, sectionId);
      });
    });
  }

  if (typeof applyView === "function") {
    const savedView =
      localStorage.getItem("productView");

    applyView(savedView || "grid");
  }
}

function sortByoptions() {
  let section = document.querySelector(
    ".collection-wrapper"
  );

  let sortBy = document.querySelectorAll(
    '[name="sort_by"]'
  );

  if (section) {
    let productsContainer = section.querySelector(
      ".collection_products"
    );

    if (!productsContainer) {
      return;
    }

    let sectionId = productsContainer.dataset.id;

    Array.from(sortBy).forEach(function (sort) {
      sort.addEventListener("change", (event) => {
        event.preventDefault();

        const sortItem = sort.closest(
          ".collection-sortby-item"
        );

        if (sortItem) {
          sortItem.classList.remove("selected");
          sortItem.classList.add("selected");
        }

        let sortMenu = section.querySelector(
          ".collection-sortby-inner"
        );

        let sortList = sortMenu
          ? sortMenu.querySelector(
              ".collection-sortby-detail"
            )
          : null;

        if (
          sortMenu &&
          sortList &&
          sortMenu.hasAttribute("open")
        ) {
          DOMAnimations.slideUp(sortList);
        }

        SidedrawerEventInit();
        getFilterData(sort, sectionId);
      });
    });
  }
}

function getFilterSidebarState(sidebar) {
  if (!sidebar) {
    return null;
  }

  const drawerBody = sidebar.querySelector(
    ".filter-drawer-body, .filter-inner-box"
  );

  return {
    openDetails: Array.from(
      sidebar.querySelectorAll(
        "details.collection-filter-wrapper"
      )
    ).map((detail, index) => ({
      index,
      label:
        detail.querySelector(
          ".collection-filter-title"
        )?.dataset?.filterLabel || "",
      open: detail.hasAttribute("open"),
    })),

    checkedValues: Array.from(
      sidebar.querySelectorAll("input:checked")
    ).map((input) => ({
      name: input.name,
      value: input.value,
      type: input.type,
    })),

    scrollTop: drawerBody
      ? drawerBody.scrollTop
      : sidebar.scrollTop,
  };
}

function restoreFilterSidebarState(
  sidebar,
  state
) {
  if (!sidebar || !state) {
    return;
  }

  state.openDetails.forEach((saved) => {
    const details = Array.from(
      sidebar.querySelectorAll(
        "details.collection-filter-wrapper"
      )
    );

    const detail =
      details.find(
        (item) =>
          item.querySelector(
            ".collection-filter-title"
          )?.dataset?.filterLabel === saved.label
      ) || details[saved.index];

    if (!detail) {
      return;
    }

    if (saved.open) {
      detail.setAttribute("open", "");
    } else {
      detail.removeAttribute("open");
    }
  });

  // NOTE: checked state is intentionally NOT restored. The server-rendered
  // sidebar already reflects the URL, which is the source of truth. Restoring
  // the old checked values re-ticked filters the shopper had just cleared, and
  // those stale ticks were then re-sent with the next filter click.

  requestAnimationFrame(() => {
    const drawerBody = sidebar.querySelector(
      ".filter-drawer-body, .filter-inner-box"
    );

    if (drawerBody) {
      drawerBody.scrollTop =
        state.scrollTop || 0;
    } else {
      sidebar.scrollTop =
        state.scrollTop || 0;
    }
  });
}

let filterRequestController = null;

// The "Clear All" link in the top bar lives outside the sidebar, so it was
// never refreshed and stayed on screen after filters were cleared.
function syncTopbarClearAll(resultData) {
  const topbar = document.querySelector(".collection-list-topbar");
  if (!topbar || !resultData) {
    return;
  }
  const selector = ":scope > a.sr-applied-filter-remove";
  const current = topbar.querySelector(selector);
  const incomingTopbar = resultData.querySelector(".collection-list-topbar");
  const incoming = incomingTopbar
    ? incomingTopbar.querySelector(selector)
    : null;

  if (current) {
    current.remove();
  }
  if (incoming) {
    topbar.insertBefore(document.importNode(incoming, true), topbar.firstChild);
  }
}

function getFilterData(
  input,
  sectionId,
  remove,
  minPriceRange,
  maxPriceRange
) {
  let section = document.getElementById(
    "CollectionProductsParent"
  );

  let filterForm =
    document.getElementById("FiltersForm");

  if (!section || !filterForm) {
    return false;
  }

  let sectionParent =
    section.closest(".shopify-section");

  let formData = new FormData(filterForm);

  let searchParameters =
    new URLSearchParams(formData).toString();

  let url =
    window.location.pathname +
    "?section_id=" +
    encodeURIComponent(sectionId);

  if (searchParameters) {
    url += "&" + searchParameters;
  }

  let updateUrl = window.location.pathname;

  if (searchParameters) {
    updateUrl += "?" + searchParameters;
  }

  if (remove) {
    const cleanRemove = normalizeCollectionUrl(String(remove).trim());
    url = buildCollectionSectionUrl(cleanRemove, sectionId);
    updateUrl = cleanRemove;
  }

  // Cancel any request still in flight, so a slower, older response can't
  // land after this one and put back filters that were just changed.
  if (filterRequestController) {
    filterRequestController.abort();
  }
  filterRequestController = new AbortController();

  fetchFilterData(url, { signal: filterRequestController.signal })
    .then((responseText) => {
      let resultData =
        new DOMParser().parseFromString(
          responseText,
          "text/html"
        );

      let element = document.getElementById(
        "CollectionProductsParent"
      );

      let html = resultData.getElementById(
        "CollectionProductsParent"
      );

      let mobileSort = document.querySelector(
        "[data-mobile-sort]"
      );

      let resultMobileSort =
        resultData.querySelector(
          "[data-mobile-sort]"
        );

      let filterElement =
        document.querySelector(
          ".collection-filter-sidebar"
        );

      let filterHtml =
        resultData.querySelector(
          ".collection-filter-sidebar"
        );

      if (!element || !html) {
        throw new Error(
          "Collection products were not returned"
        );
      }

      element.innerHTML = html.innerHTML;

      let scrollDiv =
        document.getElementById(
          "CollectionProductsParent"
        );

      if (mobileSort && resultMobileSort) {
        mobileSort.innerHTML =
          resultMobileSort.innerHTML;

        bindMobileSortOutsideClick();
      }

      if (scrollDiv) {
        scrollIntoView(scrollDiv);
      }

      if (filterElement && filterHtml) {
        const previousFilterState =
          getFilterSidebarState(filterElement);

        filterElement.innerHTML =
          filterHtml.innerHTML;

        restoreFilterSidebarState(
          filterElement,
          previousFilterState
        );
      }

      syncTopbarClearAll(resultData);

      applyFilters();
      remove_filter(sectionParent, sectionId);
      SidedrawerEventInit();

      history.pushState(
        {
          collectionUrl: updateUrl,
        },
        "",
        updateUrl
      );

      lastRenderedCollectionUrl =
        normalizeCollectionUrl(updateUrl);

      if (
        typeof collectionSwatch === "function"
      ) {
        collectionSwatch();
      }

      sortByoptions();

      triggered = false;

      if (
        typeof loadMoreCollection === "function"
      ) {
        loadMoreCollection();
      }

      if (
        typeof getCountDownElments === "function"
      ) {
        getCountDownElments();
      }

      if (
        typeof quickviewElements === "function"
      ) {
        quickviewElements();
      }

      if (
        typeof customDropdownElements ===
        "function"
      ) {
        customDropdownElements();
      }

      if (
        typeof SidedrawerEventInit === "function"
      ) {
        SidedrawerEventInit();
      }

      if (
        typeof productCardHoverInit === "function"
      ) {
        productCardHoverInit();
      }

      if (
        typeof aosAnimation !== "undefined" &&
        aosAnimation
      ) {
        if (
          typeof AOS !== "undefined" &&
          AOS
        ) {
          AOS.refreshHard();
        }
      }

      document.dispatchEvent(
        new CustomEvent(
          "collectionFilterUpdated",
          {
            detail: {
              url: updateUrl,
              // Parsed section response, so other listeners (e.g. the
              // cascade filter) can refresh their own state from it.
              doc: resultData,
            },
          }
        )
      );
    })
    .catch((error) => {
      if (error.name === "AbortError") {
        return;
      }
      console.error(
        "Unable to update collection filters:",
        error
      );
    });
}

function scrollIntoView(selector, offset = 0) {
  if (!selector) {
    return;
  }

  window.scroll(
    0,
    selector.offsetTop - offset
  );
}

let removeFilterDelegated = false;

function remove_filter() {
  // Delegated once: works for links that are re-rendered later and never
  // stacks duplicate handlers (which fired several parallel requests).
  if (removeFilterDelegated) {
    return;
  }
  removeFilterDelegated = true;

  document.addEventListener("click", function (event) {
    const removeFilter = event.target.closest(
      "a.sr-applied-filter-remove"
    );
    if (!removeFilter) {
      return;
    }

    const section = document.getElementById(
      "CollectionProductsParent"
    );
    const removeUrl = (removeFilter.getAttribute("href") || "").trim();

    // Not on a filterable page: let the link behave normally.
    if (!section || !removeUrl) {
      return;
    }

    event.preventDefault();
    getFilterData(removeFilter, section.dataset.id, removeUrl);
  });
}

function collection_price_range(
  sectionId,
  sectionParent
) {
  const rangeInput =
      document.querySelectorAll(
        ".sr-range-input input"
      ),
    priceInput =
      document.querySelectorAll(
        ".sr-price-input input"
      ),
    range = document.querySelector(
      "#priceSilderProgress"
    );

  if (
    rangeInput.length < 2 ||
    priceInput.length < 2 ||
    !range
  ) {
    return;
  }

  let priceGap = parseInt(
    rangeInput[0].getAttribute("step"),
    10
  );

  if (Number.isNaN(priceGap)) {
    priceGap = 0;
  }

  priceInput.forEach((input) => {
    input.addEventListener(
      "change",
      () => {
        let minPrice = parseInt(
          priceInput[0].value,
          10
        );

        let maxPriceRange = parseInt(
          priceInput[1].getAttribute(
            "data-max-value"
          ),
          10
        );

        if (
          !Number.isNaN(maxPriceRange) &&
          minPrice > maxPriceRange
        ) {
          minPrice = maxPriceRange;
          priceInput[0].value = minPrice;
        }

        getFilterData(input, sectionId);
      }
    );
  });

  rangeInput.forEach((input) => {
    input.addEventListener(
      "change",
      (event) => {
        rangeSlider(event);
        getFilterData(input, sectionId);
      }
    );

    input.addEventListener(
      "input",
      (event) => {
        rangeSlider(event);
      }
    );
  });

  function rangeSlider(event) {
    let minVal = parseInt(
      rangeInput[0].value,
      10
    );

    let maxVal = parseInt(
      rangeInput[1].value,
      10
    );

    if (
      Number.isNaN(minVal) ||
      Number.isNaN(maxVal)
    ) {
      return;
    }

    let minPriceRange = Math.max(
      0,
      (minVal / rangeInput[0].max) * 100
    );

    let maxPriceRange = Math.max(
      0,
      100 -
        (maxVal / rangeInput[1].max) *
          100
    );

    if (maxVal - minVal < priceGap) {
      if (
        event.target.className ===
        "priceslider-range-min"
      ) {
        rangeInput[0].value =
          maxVal - priceGap;
      } else {
        rangeInput[1].value =
          minVal + priceGap;
      }
    } else {
      priceInput[0].value = minVal;
      priceInput[1].value = maxVal;
      range.style.left =
        minPriceRange + "%";
      range.style.right =
        maxPriceRange + "%";
    }
  }
}

// Infinite scroll
function Onscrollproducts() {
  window.addEventListener(
    "scroll",
    function () {
      let scrollElement =
        document.querySelector("[data-scroll]");

      if (scrollElement) {
        infiniteScroll(scrollElement);
      }
    }
  );
}

function infiniteScroll(scrollElement) {
  if (
    !scrollElement ||
    !scrollElement.querySelector("a")
  ) {
    return;
  }

  let nextUrl = scrollElement
    .querySelector("a")
    .getAttribute("href");

  if (
    isOnScreen(scrollElement) &&
    triggered === false
  ) {
    triggered = true;

    const nextLink =
      scrollElement.querySelector("a");

    if (nextLink) {
      nextLink.remove();
    }

    const loader =
      scrollElement.querySelector(".load");

    if (loader) {
      loader.classList.remove("hidden");
    }

    fetchFilterData(nextUrl)
      .then((responseText) => {
        scrollElement.remove();

        const resultData =
          new DOMParser().parseFromString(
            responseText,
            "text/html"
          );

        let html = resultData.querySelector(
          "#CollectionProductsParent"
        );

        let element = document.querySelector(
          "#CollectionProductsParent"
        );

        if (!html || !element) {
          return;
        }

        const resultProducts =
          html.querySelector(
            "[data-collection-products]"
          );

        const currentProducts =
          element.querySelector(
            "[data-collection-products]"
          );

        if (
          resultProducts &&
          currentProducts
        ) {
          currentProducts.innerHTML +=
            resultProducts.innerHTML;

          if (
            typeof getCountDownElments ===
            "function"
          ) {
            getCountDownElments();
          }

          triggered = false;

          loadMoreCollection();

          if (
            typeof quickviewElements ===
            "function"
          ) {
            quickviewElements();
          }

          if (
            typeof productCardHoverInit ===
            "function"
          ) {
            productCardHoverInit();
          }

          if (
            typeof aosAnimation !==
              "undefined" &&
            aosAnimation
          ) {
            if (
              typeof AOS !== "undefined" &&
              AOS
            ) {
              AOS.refreshHard();
            }
          }
        }
      })
      .catch((error) => {
        triggered = false;

        console.error(
          "Unable to load more collection products:",
          error
        );
      });
  }
}

function loadMoreCollection(
  section = document
) {
  let loadmoreButton =
    section.querySelector(
      "[data-products-load]"
    );

  if (!loadmoreButton) {
    return;
  }

  loadmoreButton.addEventListener(
    "click",
    function (event) {
      event.preventDefault();

      let scrollElement =
        loadmoreButton.closest(
          "[data-load-more]"
        );

      if (scrollElement) {
        infiniteScroll(scrollElement);
      }
    }
  );
}

document.addEventListener(
  "DOMContentLoaded",
  function () {
    Onscrollproducts();
    loadMoreCollection();
  }
);

document.addEventListener(
  "shopify:block:select",
  function (event) {
    let block = event.target;

    loadMoreCollection(block);
  }
);

document.addEventListener(
  "shopify:section:load",
  function (event) {
    let section = event.target;

    loadMoreCollection(section);
  }
);

function bindMobileSortOutsideClick() {
  document.removeEventListener(
    "click",
    handleMobileSortOutsideClick
  );

  document.addEventListener(
    "click",
    handleMobileSortOutsideClick
  );
}

function handleMobileSortOutsideClick(event) {
  const sortTrigger = event.target.closest(
    "[data-mobile-sort]"
  );

  const isInsideDetailBox =
    event.target.closest(".detail-expand");

  if (sortTrigger) {
    document.body.classList.toggle(
      "mobile-sort-active"
    );
  } else if (!isInsideDetailBox) {
    document.body.classList.remove(
      "mobile-sort-active"
    );

    const detailBox =
      document.querySelector(
        ".collection-sortby-inner.active"
      );

    if (detailBox) {
      detailBox.classList.remove("active");
    }

    const expandBox =
      document.querySelector(
        ".collection-sortby-inner .detail-expand"
      );

    if (expandBox) {
      expandBox.style.display = "none";
    }
  }
}

document.addEventListener(
  "click",
  (event) => {
    const openDetails =
      document.querySelectorAll(
        ".collection-sortby-inner[open]"
      );

    if (openDetails.length === 0) {
      return;
    }

    openDetails.forEach((details) => {
      if (!details.contains(event.target)) {
        details.removeAttribute("open");
      }
    });
  }
);